const PHOTO_STORAGE_KEY = 'userProfilePhoto';

function arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    const base64String = window.btoa(binary);
    return `data:image/jpeg;base64,${base64String}`;
}

export function setProfilePhotoInStorage(arrayBuffer: ArrayBuffer) {
    const dataUrl = arrayBufferToBase64(arrayBuffer);
    localStorage.setItem(PHOTO_STORAGE_KEY, dataUrl);
    return dataUrl;
}

export function getProfilePhotoFromStorage(): string | null {
    return localStorage.getItem(PHOTO_STORAGE_KEY);
}

export function clearProfilePhotoFromStorage() {
    localStorage.removeItem(PHOTO_STORAGE_KEY);
}